export default {"src":"/newStatic/_next/static/media/world.3b67b190.svg","height":56,"width":56};